import React, {Component} from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactPlayer from 'react-player'
import Navigation from './Navigation';
import Header from './Header';
import Select from 'react-select';

class AssetPreview extends Component{
	constructor(props){
		super(props);

		this.state = {
			videoView: null
		}
	}
	
	componentWillMount(){
	}

	componentDidMount() {		
		this.makeVideoSlider();
		this.getAssetEnhancementList();
	}

	makeVideoSlider() {
		let videos = this.props.videoUrlList.map((video, index) => {
			return (<ReactPlayer key={index} url={video} controls />);
		})

		if (this.props.videoUrlList.length) {
			this.setState({
				videoView: videos
			})
		} else {
			this.setState({
				videoView: null
			})
		}
	}

	getAssetEnhancementList() {
		let temp = this.props.assetEnhancements.map((enhancement, index) => {
			return (
					<div key={index} className="enhancement-item">{enhancement.label}</div>
				)
		})

		this.setState({
			enhancementView: temp
		});
	}

	setLanguage(lang) {
	}

	checkLogin() {
	}

	render(){
		let assetBackStyle = {
			 backgroundImage: "url('" + this.props.assetImage + "')"
		};

		if (this.props.assetImage == '/assets/images/placeholder.jpg') {
			assetBackStyle = {
				backgroundImage: "url('')"
			};
		}

		let userBackStyle = {
			backgroundImage: "url('" + this.props.userAvatar + "')"
		};

		return(
			<div className="digit asset_description preview">
				<Header history={this.props.history} ref="header" dataLanguage={this.props.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} preview={false} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="3" dataLanguage={this.props.dataLanguage} history={this.props.history} />
							
							{ this.state.videoView ?
								<div className="banner-slider video-slider">
									<div className="owl-slider">
										<OwlCarousel id="videoSlider" items={1} className="owl-theme" loop nav margin={1} responsiveClass={true} >
											{ this.state.videoView }
										</OwlCarousel>
									</div>
								</div>
							: null }
							<div className="asset_info">
								<div className="row">
									<div className="col-md-3">
										<div className="back-avatar" style={assetBackStyle}>
										</div>
									</div>
									<div className="col-md-9">
										<div className="asset_details">
											<div className="row mb-15">
												<div className="col-md-4">
													<div className="profile-img">
														<div className="userAvatar" style={userBackStyle}></div>
														<p className="userName">{this.props.userName}</p>
													</div>
													{ this.props.selectedGame ?
														<p><span className="text-yellow">{this.props.dataLanguage['game']}:</span> {this.props.selectedGame.label}</p>
													: null }
													<p><span className="text-yellow">{this.props.dataLanguage['item_name']}:</span> {this.props.assetName}</p>
													{ this.props.selectedRarity ?
														<p><span className="text-yellow">{this.props.dataLanguage['rarity']}:</span> {this.props.selectedRarity.label}</p>
													: null }
												</div>
												<div className="col-md-8">
													{ this.props.description ?
														<p className="description"><span className="text-yellow">{this.props.dataLanguage['description']}:</span> {this.props.description}</p>
													: null }
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">
													{ this.state.enhancementView ?
														<div className="enhancement-list">
															{ this.state.enhancementView }
														</div>
													: null }
												</div>
												<div className="col-md-6">
													<div className="text-right">
														<div className="profile-likes">
															<span className="btn_like"><img alt="" src="/assets/images/icons/like-icon.png" />0</span>
															<span className="btn_like"><img alt="" src="/assets/images/icons/dislike-icon.png" />0</span>
														</div>
														<div className="asset_price">
															{ this.props.currency ?
																<p>{this.props.currency.label} {this.props.price}</p>
															: null }
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		)
	}
}

export default AssetPreview;


// WEBPACK FOOTER //
// ./src/components/AssetPreview.js